import { render } from "./BanAna.vue?vue&type=template&id=0641c2bc"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/BanAna.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0641c2bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0641c2bc', __exports__)) {
    api.reload('0641c2bc', __exports__)
  }
  
  module.hot.accept("./BanAna.vue?vue&type=template&id=0641c2bc", () => {
    api.rerender('0641c2bc', render)
  })

}


export default __exports__